import Head from 'expo-router/head';
import { ScrollView } from 'react-native';
import { getTokenValue, Text, YStack } from 'tamagui';

import EventLocation from '@/components/EventLocation';

/**
 * ── /components/event-location ───────────────────────────────────────────
 *
 * EventLocation — the pin icon + venue-name link row reused across
 * EventDetailMeta, CheckoutEventHeader, TicketListItem, and directly in
 * events/[id]/confirm.tsx. Its whole prop surface is `venueName` +
 * `googleMapsUrl`; tapping the name opens the maps link via `openURL`
 * (`src/utils/linkingUtils.ts`), which is a no-op here since `onPress` isn't
 * observable in a static preview — what's worth showing is just how the row
 * wears a short vs a long venue name (it doesn't wrap or truncate).
 * ─────────────────────────────────────────────────────────────────────────
 */

export default function EventLocationPreview() {
  return (
    <>
      <Head>
        <title>EventLocation · Putting Scene</title>
      </Head>
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: getTokenValue('$color.background', 'color'),
        }}
      >
        <YStack items="flex-start" gap="$lg" p="$lg">
          <YStack gap="$xs">
            <Text fontFamily="$body" fontSize="$small" color="$textDarkMuted">
              short venue name — the common case
            </Text>
            <EventLocation
              venueName="Sky Deck, Indiranagar"
              googleMapsUrl="https://maps.google.com"
            />
          </YStack>

          <YStack gap="$xs">
            <Text fontFamily="$body" fontSize="$small" color="$textDarkMuted">
              long venue name — no wrap/clamp, so watch for overflow past the
              row&apos;s container
            </Text>
            <YStack width={280}>
              <EventLocation
                venueName="The Grand Heritage Botanical Gardens & Amphitheatre, Old Airport Road, Bangalore"
                googleMapsUrl="https://maps.google.com"
              />
            </YStack>
          </YStack>
        </YStack>
      </ScrollView>
    </>
  );
}
